/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Failedtosendemail3Inputs */

const en_failedtosendemail3 = /** @type {(inputs: Failedtosendemail3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to send confirmation email`)
};

const de_failedtosendemail3 = /** @type {(inputs: Failedtosendemail3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestätigungs-E-Mail konnte nicht gesendet werden`)
};

/**
* | output |
* | --- |
* | "Failed to send confirmation email" |
*
* @param {Failedtosendemail3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const failedtosendemail3 = /** @type {((inputs?: Failedtosendemail3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Failedtosendemail3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_failedtosendemail3(inputs)
	return de_failedtosendemail3(inputs)
});
export { failedtosendemail3 as "failedToSendEmail" }